import { combineReducers } from 'redux';

import errors from './errors';

import {
  ACTION_ADD_CAMPAIGNS,
  ACTION_LOAD_CAMPAIGN_NAMES__REQUEST,
  ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS,
  ACTION_LOAD_CAMPAIGN_NAMES__FAIL,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_CAMPAIGNS:
      return { ...state, ...action.payload.campaigns };

    default:
      return state;
  }
};

const idsSortedByName = (state = [], action) => {
  switch (action.type) {
    case ACTION_LOAD_CAMPAIGN_NAMES__REQUEST:
    case ACTION_LOAD_CAMPAIGN_NAMES__FAIL:
      return [];

    case ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS:
      return action.payload.campaignIds;

    default:
      return state;
  }
};

const isNamesListLoading = (state = false, action) => {
  switch (action.type) {
    case ACTION_LOAD_CAMPAIGN_NAMES__REQUEST:
      return true;

    case ACTION_LOAD_CAMPAIGN_NAMES__SUCCESS:
    case ACTION_LOAD_CAMPAIGN_NAMES__FAIL:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  idsSortedByName,
  isNamesListLoading,
  errors,
});
